import { Message } from 'ui'

export const Prop22MileageBlock = () => {
  return (
    <Message variant="info" mb={1}>
      <strong>
        Let us know how far a worker is expected to drive in the Delivery Block.
      </strong>
      This will help us recommend competitive pay.
      <br />
      <br />
      WorkWhile requires that all California driving shifts performed by
      independent contractors must meet the following requirements:
      <br />
      <br />
      <ul
        style={{
          paddingLeft: '15px',
          listStyleType: 'disc',
        }}
      >
        <li>
          Delivery drivers may only perform delivery-related activities during
          delivery shifts (e.g., selecting and collecting the items to be
          delivered and delivering the selected items to customers)
        </li>
        <li>
          All delivery stops within the shift must be within a 50-mile radius of
          the pick-up location
        </li>
        <li>
          Drivers can be offered the opportunity to complete more than one
          delivery request on the shift
        </li>
        <li>
          Each delivery request must consist of no more than 12 distinct orders
          placed by different customers
        </li>
        <li>
          Drivers must be allowed to voluntarily decide whether to accept or
          decline each delivery request offered to them on a shift, and no
          adverse action can be taken against a driver who decides to decline a
          delivery request
        </li>
      </ul>
      <br />
      If a shift's actual mileage exceeds the estimated mileage, this may result
      in a surcharge to you, and additional payment to the worker, to comply
      with California regulatory requirements.
    </Message>
  )
}
